import { IntlShape } from 'react-intl';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import { Icon, SidebarPortal } from '@plone/volto/components';
// @ts-ignore
import tableSVG from '@plone/volto/icons/table.svg';
import DataTableSchema from './schema';
import View from './View';
import { DataTableData } from './types';

interface Props {
  intl: IntlShape;
  selected: boolean;
  onChangeBlock: (block: string, data: {}) => {};
  block: string;
  data: DataTableData;
}

const Edit: React.FC<Props> = (props) => {
  const schema = DataTableSchema(props.intl);
  return (
    <>
      <SidebarPortal selected={props.selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          icon={<Icon name={tableSVG} />}
          onChangeField={(id: string, value: string) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          formData={props.data}
        />
      </SidebarPortal>
      <View data={props.data} isEditMode={true} />
    </>
  );
};

export default Edit;
